"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file rank.proto (package rank, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseActivationCodeResponse = exports.UseActivationCodeRequest = exports.EventRank = exports.GetRanksResponse = exports.GetRanksRequest = exports.StaffMember = exports.StaffCategory = exports.GetStaffResponse = exports.GetStaffRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const common_pb_js_1 = require("./common_pb.js");
/**
 * @generated from message rank.GetStaffRequest
 */
class GetStaffRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetStaffRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetStaffRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetStaffRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetStaffRequest, a, b);
    }
}
GetStaffRequest.runtime = protobuf_1.proto3;
GetStaffRequest.typeName = "rank.GetStaffRequest";
GetStaffRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
exports.GetStaffRequest = GetStaffRequest;
/**
 * @generated from message rank.GetStaffResponse
 */
class GetStaffResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated rank.StaffCategory category = 1;
         */
        this.category = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetStaffResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetStaffResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetStaffResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetStaffResponse, a, b);
    }
}
GetStaffResponse.runtime = protobuf_1.proto3;
GetStaffResponse.typeName = "rank.GetStaffResponse";
GetStaffResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "category", kind: "message", T: StaffCategory, repeated: true },
]);
exports.GetStaffResponse = GetStaffResponse;
/**
 * @generated from message rank.StaffCategory
 */
class StaffCategory extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string category = 1;
         */
        this.category = "";
        /**
         * @generated from field: repeated rank.StaffMember member = 2;
         */
        this.member = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StaffCategory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StaffCategory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StaffCategory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(StaffCategory, a, b);
    }
}
StaffCategory.runtime = protobuf_1.proto3;
StaffCategory.typeName = "rank.StaffCategory";
StaffCategory.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "member", kind: "message", T: StaffMember, repeated: true },
]);
exports.StaffCategory = StaffCategory;
/**
 * @generated from message rank.StaffMember
 */
class StaffMember extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string uuid = 1;
         */
        this.uuid = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string position = 3;
         */
        this.position = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StaffMember().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StaffMember().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StaffMember().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(StaffMember, a, b);
    }
}
StaffMember.runtime = protobuf_1.proto3;
StaffMember.typeName = "rank.StaffMember";
StaffMember.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "position", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.StaffMember = StaffMember;
/**
 * @generated from message rank.GetRanksRequest
 */
class GetRanksRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetRanksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRanksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRanksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetRanksRequest, a, b);
    }
}
GetRanksRequest.runtime = protobuf_1.proto3;
GetRanksRequest.typeName = "rank.GetRanksRequest";
GetRanksRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
exports.GetRanksRequest = GetRanksRequest;
/**
 * @generated from message rank.GetRanksResponse
 */
class GetRanksResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated rank.EventRank ranks = 1;
         */
        this.ranks = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetRanksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRanksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRanksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetRanksResponse, a, b);
    }
}
GetRanksResponse.runtime = protobuf_1.proto3;
GetRanksResponse.typeName = "rank.GetRanksResponse";
GetRanksResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ranks", kind: "message", T: EventRank, repeated: true },
]);
exports.GetRanksResponse = GetRanksResponse;
/**
 * @generated from message rank.EventRank
 */
class EventRank extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 id = 1;
         */
        this.id = 0;
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string nameColor = 3;
         */
        this.nameColor = "";
        /**
         * @generated from field: string chatColor = 4;
         */
        this.chatColor = "";
        /**
         * @generated from field: string prefix = 5;
         */
        this.prefix = "";
        /**
         * @generated from field: int32 priority = 6;
         */
        this.priority = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EventRank().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventRank().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventRank().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EventRank, a, b);
    }
}
EventRank.runtime = protobuf_1.proto3;
EventRank.typeName = "rank.EventRank";
EventRank.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "nameColor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "chatColor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
exports.EventRank = EventRank;
/**
 * @generated from message rank.UseActivationCodeRequest
 */
class UseActivationCodeRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string code = 2;
         */
        this.code = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UseActivationCodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UseActivationCodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UseActivationCodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UseActivationCodeRequest, a, b);
    }
}
UseActivationCodeRequest.runtime = protobuf_1.proto3;
UseActivationCodeRequest.typeName = "rank.UseActivationCodeRequest";
UseActivationCodeRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "player", kind: "message", T: common_pb_js_1.PlayerIdentifier },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.UseActivationCodeRequest = UseActivationCodeRequest;
/**
 * @generated from message rank.UseActivationCodeResponse
 */
class UseActivationCodeResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        /**
         * @generated from field: string message = 2;
         */
        this.message = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UseActivationCodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UseActivationCodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UseActivationCodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UseActivationCodeResponse, a, b);
    }
}
UseActivationCodeResponse.runtime = protobuf_1.proto3;
UseActivationCodeResponse.typeName = "rank.UseActivationCodeResponse";
UseActivationCodeResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.UseActivationCodeResponse = UseActivationCodeResponse;
